/**
 * DataBest — Protected route wrapper.
 * Redirects to /login if unauthenticated. Waits for auth hydration first.
 */
import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import useAuthStore from "@/store/authStore";
import { DataBestLogoShieldNetwork } from "@/components/DataBestLogo";

const ProtectedRoute = ({ children, roles }) => {
    const location = useLocation();
    const { user, accessToken, initializing } = useAuthStore();

    if (initializing) {
        return (
            <div
                className="flex min-h-[100dvh] items-center justify-center bg-brand-blue-950"
                data-testid="protected-loading"
            >
                <div className="flex flex-col items-center gap-4">
                    <DataBestLogoShieldNetwork size={56} variantId="loading" />
                    <p className="text-sm text-white/60">Loading DataBest…</p>
                </div>
            </div>
        );
    }

    if (!accessToken || !user) {
        return <Navigate to="/login" replace state={{ from: location }} />;
    }

    if (roles && Array.isArray(roles) && !roles.includes(user.role)) {
        return (
            <div
                className="flex min-h-[60dvh] items-center justify-center p-6"
                data-testid="rbac-denied"
            >
                <div className="max-w-md rounded-2xl border border-red-200 bg-red-50 p-6 text-center">
                    <h2 className="font-heading text-xl font-bold text-red-900">
                        Access denied
                    </h2>
                    <p className="mt-2 text-sm text-red-800">
                        Your role ({user.role}) is not permitted to view this
                        page.
                    </p>
                </div>
            </div>
        );
    }

    return children;
};

export default ProtectedRoute;
